import { render, staticRenderFns } from "./DevolucionIngresoTardio.vue?vue&type=template&id=1a249641&scoped=true"
import script from "./DevolucionIngresoTardio.vue?vue&type=script&lang=ts"
export * from "./DevolucionIngresoTardio.vue?vue&type=script&lang=ts"
import style0 from "./DevolucionIngresoTardio.vue?vue&type=style&index=0&id=1a249641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a249641",
  null
  
)

export default component.exports